import { render, staticRenderFns } from "./ContainerStatusDetailForm.vue?vue&type=template&id=36c3f384"
import script from "./ContainerStatusDetailForm.vue?vue&type=script&lang=js"
export * from "./ContainerStatusDetailForm.vue?vue&type=script&lang=js"
import style0 from "./ContainerStatusDetailForm.vue?vue&type=style&index=0&id=36c3f384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports